import { useEffect, useState } from 'react';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import CheckboxRadio from 'components/common/CheckboxRadio/CheckboxRadio';

type AuthPageFooterProps = {
  requestPasswordReset?: () => void;
};

function isValidRememberMeValue(rememberMeValue: string | null) {
  return rememberMeValue === 'true' || rememberMeValue === 'false';
}

export function getRememberMeValue(): boolean | null {
  const rememberMeFromLocalStorage = localStorage.getItem('rememberMe');
  if (rememberMeFromLocalStorage && isValidRememberMeValue(rememberMeFromLocalStorage)) {
    return JSON.parse(rememberMeFromLocalStorage);
  }
  return null;
}

function setRememberMeValue() {
  const rememberMeFromLocalStorage = getRememberMeValue();
  if (rememberMeFromLocalStorage !== null) {
    return rememberMeFromLocalStorage;
  }
  localStorage.setItem('rememberMe', 'true');
  return true;
}

function AuthPageFooter({ requestPasswordReset }: AuthPageFooterProps): JSX.Element {
  const [rememberMe, setRememberMe] = useState<boolean>(setRememberMeValue);

  function handleRememberMe() {
    setRememberMe((prevValue) => !prevValue);
  }

  useEffect(() => {
    localStorage.setItem('rememberMe', `${rememberMe}`);
  }, [rememberMe]);

  return (
    <div className="AuthPage__Form__Footer">
      <CheckboxRadio
        type="checkbox"
        name="rememberMe"
        label="Remember me"
        onChange={handleRememberMe}
        checked={rememberMe}
      />
      {requestPasswordReset ? (
        <Button variant={ButtonVariant.BORDERLESS} onClick={requestPasswordReset}>
          Forgot password?
        </Button>
      ) : (
        <a className="AuthPage__Form__ContactUsLink" href="https://www.dataset.com/contact/">
          Contact us
        </a>
      )}
    </div>
  );
}

export default AuthPageFooter;
